import type { ReactNode } from "react";

/**
 * The app's two heading levels.
 *
 * These exist as components rather than as class strings copied into 25 call
 * sites, because the problem they fix was the absence of a scale, and a scale
 * that lives in 25 places stops being one on the first edit.
 *
 * What was there before: `text-xl` for every h1 and `text-lg` for every h2 and
 * every stat value. Four sizes in the whole app spanning 20px to 12px, so the
 * largest jump in the system was 20/18 = 1.11x and nothing on any page read as
 * dominant -- a page title, a section label and a number weighed the same.
 *
 * Both are now quiet, which is the point. The page title in particular is
 * chrome: the nav already says which page you are on, and on a phone it says
 * so in the bottom bar. Demoting it is what lets the DATA be the largest thing
 * on the page, which is the difference between a tool and a wireframe.
 */
export function PageTitle({ children }: { children: ReactNode }) {
  return (
    <h1 className="text-xs font-semibold uppercase tracking-[0.14em] text-neutral-500">
      {children}
    </h1>
  );
}

export function SectionTitle({ children }: { children: ReactNode }) {
  return (
    <h2 className="text-[13px] font-semibold uppercase tracking-wider text-neutral-400">
      {children}
    </h2>
  );
}
